import { useIntl } from 'react-intl';
import AntdFormItem from '../../../../../../../components/AntdFormItem';
import AntdInput from '../../../../../../../components/AntdInput';
import PropTypes from '../../../../../../../utils/propTypes';

const DeliveryFormFields = ({ editMode }) => {
  const intl = useIntl();
  return (
    <>
      <div className="col-sx-12 col-md-4">
        <AntdFormItem
          name="templateName"
          label={intl.formatMessage({
            id: 'pages.quality.ocr.templates.create.delivery.templateLayout.field.templateName',
          })}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'validations.required' }),
            },
            {
              max: 30,
              message: intl.formatMessage(
                { id: 'validations.maxLength' },
                { max: 30 },
              ),
            },
          ]}
        >
          <AntdInput size="large" />
        </AntdFormItem>
      </div>
      <div className="col-sx-12 col-md-4">
        <AntdFormItem
          name="supplier_id"
          label={intl.formatMessage({
            id: 'pages.quality.ocr.templates.create.delivery.templateLayout.field.supplier_id',
          })}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'validations.required' }),
            },
            {
              max: 30,
              message: intl.formatMessage(
                { id: 'validations.maxLength' },
                { max: 30 },
              ),
            },
          ]}
        >
          <AntdInput size="large" disabled={editMode} />
        </AntdFormItem>
      </div>
    </>
  );
};

DeliveryFormFields.propTypes = {
  editMode: PropTypes.bool,
};

DeliveryFormFields.defaultProps = {
  editMode: false,
};

export default DeliveryFormFields;
